(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-games-from-contentlist.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-games-from-contentlist.js');

'use strict';

const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  normalizeCardData
} = svs.components.casino_react.common.utils;
const {
  CardType
} = svs.components.casino_react.common.constants;
const useGamesFromContentList = listId => {
  const [games, setGames] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchCategoryGames = useCallback(async categoryListId => {
    if (!categoryListId) {
      setError('Missing list id');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await svs.core.jupiterFetch.get("content/2/listfilter?listId=".concat(categoryListId, "&onlyName=true&routesDomain=spela&count=5000&channel=").concat(svs.core.data.capabilities.channel));
      const jsonRes = await res.json();
      if (jsonRes.result) {
        const normalizedResponse = jsonRes.result.map(game => normalizeCardData(game, CardType.GAME));
        setGames(normalizedResponse);
        setTotalCount(jsonRes.totalCount);
      } else {
        setGames([]);
        setTotalCount(0);
      }
    } catch (e) {
      setError(e);
      setGames([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchCategoryGames(listId);
  }, [listId, fetchCategoryGames]);
  return {
    games,
    totalCount,
    loading,
    error
  };
};
setGlobal('svs.components.casino_react.hooks.useGamesFromContentList', useGamesFromContentList);

 })(window);